module.exports = __webpack_public_path__ + "img/banner-catering-1.ffa88a05.png";